// /**
//  * Report List
//  */

// React
import React from 'react';

import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from '@material-ui/core/styles';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
} from '@material-ui/core';

// Context
import jMoment from 'moment-jalaali';
import RonadIcons from '../../../../components/iconComponent';

type Data = any;
type Props = {
  data: any;
};

type Ord = 'asc' | 'desc';

interface HeadCell {
  id: keyof Data;
  label: string;
}

interface EnhancedTableProps {
  classes: ReturnType<typeof useStyles>;
  onRequestSort: (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => void;
  order: Ord;
  orderBy: string;
  rowCount: number;
}

// Style
const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
    },
    // table: {
    //   minWidth: 750,
    // },
    columnText: {
      padding: '0 10px',
    },
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    dot: {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      left: '-8px',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
    },
  })
);

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: {[key in Key]: number | string},
  b: {[key in Key]: number | string}
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const IconSort = (order: Ord) => {
  return (
    <RonadIcons name={order === 'asc' ? 'chevronDown' : 'chevronUp'} size={1} />
  );
};

const headCells: HeadCell[] = [
  {
    id: 'type',
    label: 'نوع',
  },
  {
    id: 'id',
    label: 'شناسه',
  },
  {
    id: 'sourceName',
    label: 'مبدا',
  },
  {
    id: 'destinationName',
    label: 'مقصد',
  },
];

function EnhancedTableHead(props: EnhancedTableProps) {
  const {order, orderBy, onRequestSort} = props;
  const classes = useStyles();
  const createSortHandler =
    (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
      onRequestSort(event, property);
    };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, i) => {
          let orderStatus = orderBy === headCell.id ? order : 'asc';
          return (
            <StyledTableCell
              key={i}
              align="center"
              sortDirection={orderBy === headCell.id ? order : false}
              data-cy={headCell.id}
            >
              {/* <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                IconComponent={() => IconSort(orderStatus)}
              > */}
              <span className={classes.columnText}>{headCell.label}</span>
              {/* </TableSortLabel> */}
            </StyledTableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default function EnhancedTable(props: Props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState<keyof Data>('amount');
  const [dense] = React.useState(false);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <div className={classes.root}>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          aria-labelledby="tableTitle"
          size={dense ? 'small' : 'medium'}
          aria-label="enhanced table"
        >
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={props?.data?.length}
          />
          <TableBody>
            {props.data &&
              stableSort(props?.data, getComparator(order, orderBy))
                .slice()
                .map((row: any, index: number) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow key={index}>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        align="center"
                      >
                        <p>
                          {row?.type === 'OUTPUT'
                            ? 'سفارش'
                            : row?.type === 'OUTPUT_RECEIPT'
                            ? 'قبض خروج'
                            : 'محموله'}
                        </p>
                        <p>
                          {row.date &&
                            jMoment(row?.date, 'YYYY/MM/DD')
                              .locale('fa')
                              .format('jYYYY/jMM/jDD')}
                        </p>
                      </TableCell>
                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        align="center"
                      >
                        <p>{row?.id}</p>
                        <p>تعداد: {row?.amount}</p>
                      </TableCell>
                      <TableCell align="center">{row?.sourceName}</TableCell>
                      <TableCell align="center">
                        {row?.destinationName}
                      </TableCell>
                    </TableRow>
                  );
                })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
